import { useState, useEffect } from "react";
import { useNavigate  } from 'react-router-dom';

import { Input, Row, Col, notification, Modal } from "antd";
import {
  MailTwoTone,
  LockTwoTone,
  CodeTwoTone
} from "@ant-design/icons";

import { Auth } from 'aws-amplify';

import moment from "moment";

export default function ChangePassword(){
  const navigate = useNavigate();

  const [username, setUsername] = useState(null);
  const [verificationCode, setVerificationCode] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [loading, setLoading] = useState(false);
  const [newPasswordBtn, setNewPasswordBtn] = useState(false);
  const [showDay, setShowDay] = useState(null);
  const [showDate, setShowDate] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    var date = moment().format("MMMM Do YYYY");
    var day = moment().format("dddd");
    setShowDay(day);
    setShowDate(date);
  }, [])

  const showModalInstructions = () => {
    setIsModalVisible(true);
  }

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleCode = (e) => {
    e.preventDefault();

    if(username){
      Auth.forgotPassword(username)
        .then(data => {
          console.log(data);
          setNewPasswordBtn(true);
          if(data){
            setIsModalVisible(true);

            notification["info"]({
              message: "Information",
              description: "If you didn't receive your change password email with the verification code, please click the link below for more instructions.",
              duration: 120000,
            });
          }
          
        })
        .catch(err => console.log(err));
    }else {
      notification["error"]({
        message: "Error",
        description:
          "Enter your username.",
      });
    }
  }

  const handleNewPassword = e => {
    e.preventDefault();

    setLoading(true);

    Auth.forgotPasswordSubmit(username, verificationCode, newPassword).then(() => {
      
      notification["success"]({
        message: "Success",
        description:
          "Your password was changed. You may proceed to login again.",
      });

      setTimeout(() => {
        navigate("/login")
      }, 2000);

    })
    .catch(err => {
      notification["error"]({
        message: "Error",
        description:
          "Please contact administrator for further instruction.",
      });
      console.log(err)
    });

  }

  return (
    <>
      <Modal title="Why I didn't receive my 'Change Password' verification Code in my email?" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
        <p><b>Possible reasons: </b></p>
        <ul>
          <li>The verification Code email is sent to your "Junk" folder or "Spam" folder. </li>
          <li>
            There could be a delay in sending the email.
            <p><em>Delay could be:</em></p>
            <ul>
              <li>due to internet connection, or speed</li>
              <li>your internet provider</li>
              <li>your email provider</li>
              <li>your device speed or memory</li>
            </ul>
            <p></p>
            <p><em>What to do:</em></p>
            <ul>
              <li>please give it at least 2-3 minutes to receive the email</li>
              <li>
                occasionally you may need to manually <em>refresh</em> your browser to check for new emails in your inbox.
              </li>
              <li>if you didn't receive it after that time, resend <em>code</em> again</li>
              <li>when all else fails, please register again using a <em>different</em> email address</li>
            </ul>
          </li>
        </ul>
        <p></p>
        <p><b>If you've tried the steps above and still haven't received your verification code for Change Password email, please contact our Support Team.</b></p>
      </Modal>

      <div className="mainLogin-div">
        <div className="mainHeader-login">
           <div className="loginHead-title">
                <img
                src="https://quezoncity.gov.ph/wp-content/themes/qcproject/images/qclogo_main.png"
                alt="QCLogo"
                />
                <span><b style={{fontSize:"20px"}}>Q</b>uezon <b style={{fontSize:"20px"}}>C</b>ity</span>
			</div>
          <div className="loginHead-date">
            {`${showDay}, ${showDate}`}
          </div>
        </div>
        <div className="loginCard-div">
       
          <form autoComplete="none" className="loginCard-left">
            <div className="loginTitle" style={{marginBottom:"10px", fontSize:"50px"}}>
						QC
                </div>
                <div className="loginTitle" style={{marginBottom:"10px", fontWeight:"normal"}}>
                    Department of Building Official<br/>
                </div>			
                    
                {/* <Alert message={`Beta Version`} type="info" style={{width:"80%",textAlign:"center", margin:15}} className="LoginTest"/> */}
                <div class="alert alert-warning" role="alert" style={{width:"80%", textAlign:"center",}}>
                    Change Password
                </div>
            {
              newPasswordBtn === false? (
                <span>
                  <Input
                    id="uname"
                    prefix={<MailTwoTone />}
                    placeholder=" Email Address"
                    onChange={(e) => setUsername( e.target.value )}
                    className="loginInput"
                    type="email"
                    required
                    autoFocus
                  />
                </span>) : ("")
            }

            {
              newPasswordBtn === true? (
                <>
                  <span>
                    <label className="loginInput-label" htmlFor="verificationCode">
                      Verification Code
                    </label>
                    <Input
                      id="verificationCode"
                      autoComplete="none"
                      prefix={<CodeTwoTone />}
                      type="text"
                      placeholder=" Your verification code"
                      name="verificationCode"
                      onChange={(e) => setVerificationCode(e.target.value)}
                      required
                      className="loginInput"
                    />
                  </span>

                  <span>
                    <label className="loginInput-label" htmlFor="newPassword">
                      New Password
                    </label>
                    <Input.Password
                      id="newPassword"
                      name="newPassword"
                      autoComplete="new-password"
                      prefix={<LockTwoTone />}
                      placeholder=" Your new password"
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                      className="loginInput"
                    />
                  </span>
                </>
                ) : ("")
            }

            {
              newPasswordBtn === true? (
                <span>
                  <button className="btns btnLogin" disabled={loading} onClick={handleNewPassword}>
                    Submit new password
                  </button>
                </span>
              ) : ("")
            }

            {
              newPasswordBtn === false? (
                <span>
                  <button className="btns btnLogin" onClick={handleCode}>
                    Send code to email
                  </button>
                </span>
                ) : ("")
            }
            
            <div className="regFoot">
              <span>&nbsp;</span>
              <span
                className="regFoot"
                onClick={() => navigate("/login")}
              >
                Login instead
              </span>
            </div>

            <div className="regFoot">
              <span><em><b>I didn't receive my Verification Code.</b></em></span>{" "}
              <span onClick={() => showModalInstructions()}>
                Instructions here
              </span>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}